package content

import dev.fritz2.dom.html.RenderContext

fun RenderContext.footer() = a {
    +"Made with ❤️ by Londogard"
    href("https://londogard.com")
    target("_blank")
}